export default {
  isLoading: false,
};
